export const messages = {
  en: {
    allocationStorehouseManage: {
      search: {
        title: 'Search Conditions',
        startUserName: 'Please enter applicant name',
        applyType: 'Please select type',
        startTime: 'Please select allocation start time',
        endTime: 'Please select allocation end time'
      },
      list: {
        title: 'Allocation Records',
        allocation: 'Allocation'
      },
      table: {
        applyId: 'No.',
        applyCount: 'Allocation/Return',
        startUserName: 'Applicant',
        stateName: 'Status',
        applyTypeName: 'Type',
        createTime: 'Time'
      },
      operation: {
        cancel: 'Cancel Allocation',
        detail: 'Detail',
        flowChart: 'Flow Chart'
      }
    },
    allocationStorehouse: {
      title: 'Apply Allocation',
      sourceWarehouse: 'Source Warehouse',
      targetWarehouse: 'Target Warehouse',
      itemName: 'Item Name',
      stock: 'Stock',
      allocationCount: 'Allocation Count',
      remark: 'Remark',
      requiredSourceWarehouse: 'Required, please select source warehouse',
      requiredTargetWarehouse: 'Required, please select target warehouse',
      requiredItemName: 'Required, please enter item name',
      requiredStock: 'Required, please enter stock',
      requiredAllocationCount: 'Required, please enter allocation count',
      requiredRemark: 'Required, please enter remark',
      positiveNumber: 'Must be positive integer',
      remarkTooLong: 'Remark is too long'
    },
    deleteStorehouseManage: {
      title: 'Please confirm your operation',
      confirmCancel: 'Confirm to cancel allocation?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteError: 'Failed to cancel allocation'
    }
  },
  zh: {
    allocationStorehouseManage: {
      search: {
        title: '查询条件',
        startUserName: '请输入申请人姓名',
        applyType: '请选择类型',
        startTime: '请选择调拨开始时间',
        endTime: '请选择调拨结束时间'
      },
      list: {
        title: '调拨记录',
        allocation: '调拨'
      },
      table: {
        applyId: '编号',
        applyCount: '调拨/退还',
        startUserName: '申请人',
        stateName: '状态',
        applyTypeName: '类型',
        createTime: '时间'
      },
      operation: {
        cancel: '取消调拨',
        detail: '详情',
        flowChart: '流程图'
      }
    },
    allocationStorehouse: {
      title: '申请调拨',
      sourceWarehouse: '源仓库',
      targetWarehouse: '目标仓库',
      itemName: '物品名称',
      stock: '库存',
      allocationCount: '调拨数量',
      remark: '备注',
      requiredSourceWarehouse: '必填，请选择源仓库',
      requiredTargetWarehouse: '必填，请选择目标仓库',
      requiredItemName: '必填，请填写物品名称',
      requiredStock: '必填，请填写库存',
      requiredAllocationCount: '必填，请填写调拨数量',
      requiredRemark: '必填，请填写备注',
      positiveNumber: '必须为正整数',
      remarkTooLong: '备注太长'
    },
    deleteStorehouseManage: {
      title: '请确认您的操作',
      confirmCancel: '确定取消调拨？',
      cancel: '点错了',
      confirm: '确认取消',
      deleteError: '取消调拨失败'
    }
  }
}